import React from 'react';
import { FiX, FiCheck } from 'react-icons/fi';

const Comparison: React.FC = () => {
  return (
    <div className="py-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          See the Privacy Difference
        </h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Every time you shorten a link, you're making a choice about your privacy. 
          Here's what happens with your data:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {/* Traditional URL Shorteners */}
        <div className="card border-2 border-red-100 bg-red-50/50">
          <h3 className="text-xl font-semibold text-gray-900 mb-6">
            Traditional URL Shorteners
          </h3>
          <ul className="space-y-4">
            <li className="flex items-start">
              <FiX className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Logs your IP address</strong> - Creates a permanent record of your location and identity
              </span>
            </li>
            <li className="flex items-start">
              <FiX className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Sets tracking cookies</strong> - Follows you across the web for advertising
              </span>
            </li>
            <li className="flex items-start">
              <FiX className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Sells data to advertisers</strong> - Your clicks become someone else's profit
              </span>
            </li>
            <li className="flex items-start">
              <FiX className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Device fingerprinting</strong> - Builds a unique profile even in incognito mode
              </span>
            </li>
            <li className="flex items-start">
              <FiX className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Shares with third parties</strong> - Your data ends up in unknown databases
              </span>
            </li>
            <li className="flex items-start">
              <FiX className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Stores browsing patterns</strong> - Creates a detailed history of your interests
              </span>
            </li>
          </ul>
        </div>

        {/* AnonLink */}
        <div className="card border-2 border-green-100 bg-green-50/50">
          <h3 className="text-xl font-semibold text-gray-900 mb-6">
            AnonLink
          </h3>
          <ul className="space-y-4">
            <li className="flex items-start">
              <FiCheck className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>No IP logging</strong> - We never store or process your IP address
              </span>
            </li>
            <li className="flex items-start">
              <FiCheck className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Zero cookies required</strong> - Works perfectly without any tracking
              </span>
            </li>
            <li className="flex items-start">
              <FiCheck className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>No data sales ever</strong> - Your privacy isn't for sale at any price
              </span>
            </li>
            <li className="flex items-start">
              <FiCheck className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>No fingerprinting</strong> - We don't collect device or browser info
              </span>
            </li>
            <li className="flex items-start">
              <FiCheck className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>No third-party sharing</strong> - Your data stays with you
              </span>
            </li>
            <li className="flex items-start">
              <FiCheck className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Privacy by design</strong> - Built from the ground up to protect you
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 text-center">
        <p className="text-gray-600 max-w-2xl mx-auto">
          With AnonLink, you get all the convenience of a modern URL shortener without sacrificing your privacy. 
          It's not just a feature—it's our foundation.
        </p>
      </div>
    </div>
  );
};

export default Comparison;